"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.sortJson = void 0;
require("core-js/modules/es.array.sort.js");
const sortJson = (json, objectPath) => {
  try {
    return json.sort((objectA, objectB) => objectA[objectPath].localeCompare(objectB[objectPath]));
  } catch (TypeError) {
    console.log(TypeError);
    return [];
  }
};
exports.sortJson = sortJson;